import { DayOfWeek, DatePicker, DirectionalHint, TooltipHost } from "../../fluent";
import { DateTime } from "../helpers/datetime";
import React from "react";
const DatePickerStrings = {
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    days: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'],
    shortDays: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    goToToday: 'Ir a hoy',
    prevMonthAriaLabel: 'Ir al mes anterior',
    nextMonthAriaLabel: 'Ir al proximo mes',
    prevYearAriaLabel: 'Ir al año anterior',
    nextYearAriaLabel: 'Ir al proximo año'
};
function onFormatDate(date) {
    if (typeof (date) === 'string') {
        date = new Date(date);
    }
    let day = String(date.getDate());
    day = day.length === 1 ? '0' + day : day;
    let month = String(date.getMonth() + 1);
    month = month.length === 1 ? '0' + month : month;
    if (typeof (date) === 'object') {
        return day + '/' + month + '/' + (date.getFullYear());
    }
    else {
        return date;
    }
}
;
export const ExtendedDatePicker = (props) => {
    let value = props.value;
    if (typeof value === 'string') {
        if (value.trim().length > 0) {
            value = new DateTime(value).ToJsDate();
        }
    }
    const onChanged = (date) => {
        if (date != null) {
            const str = new DateTime(date).ToString('DD/MM/yyyy');
            props.onChanged(str);
        }
        else {
            props.onChanged('');
        }
    };
    return React.createElement(TooltipHost, { content: props.label, directionalHint: DirectionalHint.leftCenter },
        React.createElement(DatePicker, { firstDayOfWeek: DayOfWeek.Sunday, strings: DatePickerStrings, placeholder: props.placeholder, isRequired: props.isRequired, label: props.label, formatDate: onFormatDate, onSelectDate: onChanged, value: value, allowTextInput: false, disabled: props.disabled || false }),
        React.createElement("small", { style: { color: '#bb3737' } }, props.errorMessage));
};
